// extracted by mini-css-extract-plugin
export default {"title":"headline_title__UFSdi","cursor":"headline_cursor__DSL6P","hasAnimation":"headline_hasAnimation__GqTUF","blink":"headline_blink__mzfiJ","-1":"headline_-1__qeStf"};